<template>
  <v-app-bar
    id="app-bar"
    app
    height="70px"
    flat
    clipped-left
    color="#2863af"
  >
    <v-container fluid>
      <v-row
        class="align-center"
        no-gutters
      >
        <v-col
          cols="12"
          sm="4"
          md="4"
          lg="4"
          class="d-flex align-center"
        >
          <v-row>
            <v-col
              id="logoBi"
              cols="12"
              sm="2"
              md="2"
              lg="2"
            >
              <v-img
                id="iconImgHeader"
                height="80"
                contain
                :src="require('@/assets/magistech_logo_branca.png')"
              />
            </v-col>
            <v-col
              id="iconeClicado"
              cols="12"
              sm="2"
              md="2"
              lg="2"
            >
              <v-btn
                text
                color="white"
                style="margin: 0.2rem 0 0 1rem"
                @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)"
              >
                <v-icon v-if="value">
                  mdi-view-quilt
                </v-icon>
                <v-icon v-else>
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="8"
              md="8"
              lg="8"
            >
              <div
                id="textoPagina"
                class="text-h5 font-bold-light"
                :style="styleObjectTexto"
              >
                {{ texto }}
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          id="btnSair"
          cols="12"
          sm="8"
          md="8"
          lg="8"
          class="d-flex justify-end align-center"
        >
          <v-btn
            id="sair"
            text
            color="white"
            style="margin: 0.15rem 0 0 0"
            @click="logout()"
          >
            <v-icon>
              mdi-logout
            </v-icon>
            Sair
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import Login from '../../../../services/login'
  import eventEmit from './EventoEmit'

  export default {
    name: 'DashboardCoreAppBar',
    components: {
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      notifications: [
        'Mike John Responded to your email',
        'You have 5 new tasks',
        'You\'re now friends with Andrew',
        'Another Notification',
        'Another one',
      ],
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectTexto: {
        color: 'white',
      },
      corPrimaria: localStorage.corPrimaria,
      imagem: localStorage.imagem,
      cart: 0,
      profile: [
        {
          title: 'Perfil',
          to: '/editar-perfil',
        },
        { title: 'Configurações' },
        { divider: true },
        {
          title: 'Log out',
          to: '/',
        },
      ],
      nomeUsuario: localStorage.nome,
      texto: '',
    }),

    computed: {
      ...mapState(['drawer']),
      computedOnLine () {
        if (navigator.onLine) {
          return true
        } else {
          return false
        }
      },
    },

    created () {
      eventEmit.$on('atualizar_texto', this.updateTexto)
    },

    beforeDestroy () {
      eventEmit.$off('atualizar_texto', this.updateTexto)
    },

    mounted () {
      if (localStorage.countDownViewMenu <= 15) {
        this.setDrawer(!this.drawer)
        localStorage.countDownViewMenu++
      }
    },

    methods: {
      updateTexto (texto) {
        this.texto = texto.toUpperCase()
      },

      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),

      logout () {
        Login.logout(localStorage.username, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            localStorage.removeItem('username')
            localStorage.removeItem('email')
            localStorage.removeItem('nome')
            localStorage.removeItem('usuarioIdentificado')
            localStorage.removeItem('userUsername')
            localStorage.removeItem('userId')

            this.$router.push('/login')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.message === 'Usuário não encontrado') {
            this.showSnackbar('error', 3000, 'Usuário não encontrado')
          } else if (e.data.message === 'Contrato não encontrato') {
            this.showSnackbar('error', 3000, 'Contrato não encontrato')
          }
        })
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #logoBi {
      margin: 0.8rem 0 0 -1rem;
    }

    #iconeClicado {
      margin: -1.5rem 0 0 1rem;
    }

    #textoPagina {
      margin: -4.2rem 0 0 6rem;
      font-size: 0.8rem !important;
    }

    #btnSair {
      margin: -6.5rem 0 0 2rem;
    }

    .v-icon {
      font-size: 13px;
    }

    #iconImgHeader {
      width: 7rem;
      margin: -1rem 0 0 -2rem
    }
  }
</style>

<style lang="sass">
  #iconImgHeader
    width: 10rem
    position: absolute
    margin: -1rem 0 0 -2.5rem

  #textoPagina
    margin: 0.7rem 0 0 1rem

</style>
